// extracted by mini-css-extract-plugin
export var blue = "GradientBulletPoint-module--blue--Bv2nP";
export var orange = "GradientBulletPoint-module--orange--8yOMf";
export var wrapper = "GradientBulletPoint-module--wrapper--EZegW";